"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
const getDomainEnvironmentPrefix = () => {
    return pplsi.envPrefix;
};
const getDomainEnvironment = () => {
    return pplsi.env;
};
const getRealmDomainEnvironment = () => {
    return pplsi.realmDomain;
};
const getEnvironmentUrl = (url) => {
    var _a;
    const isNode = new Function('try {return this===global;}catch(e){return false;}');
    // check if running in browser context
    if (isNode()) {
        const LS_ENV = process.env.LS_ENV || 'prod';
        if (url.includes(`.dev-`) || url.includes(`.uat-`)) {
            return url;
        }
        // Check if LS_ENV is "dev" or "uat"
        if (LS_ENV === 'dev') {
            return url.replace(/\.api\./, '.api.dev-');
        }
        else if (LS_ENV === 'uat') {
            return url.replace(/\.api\./, '.api.uat-');
        }
        else {
            return url;
        }
    }
    else {
        // Get the realm domain E.g. dev-legalshieldproviders.com
        const realmDomain = (_a = getRealmDomainEnvironment()) !== null && _a !== void 0 ? _a : '';
        // Check if the url already includes “.dev-” or “.uat-”
        if (url.includes(`.dev-`) || url.includes(`.uat-`) || realmDomain === '') {
            return url;
        }
        const regexForEnvsToReplace = /\blegalshield.com|legalshieldinternal.com|legalshieldproviders.com|legalshieldatwork.com\b/;
        // Injects env if needed, also ensures that we're using the correct realm
        return url.replace(regexForEnvsToReplace, realmDomain);
    }
};
const getAppName = (hostName) => {
    if (hostName === pplsi.realmDomain)
        return '';
    return hostName.replace('.' + pplsi.realmDomain, '');
};
exports.Environment = {
    getAppName,
    getDomainEnvironment,
    getDomainEnvironmentPrefix,
    getEnvironmentUrl,
    getRealmDomainEnvironment,
};
//# sourceMappingURL=environment.js.map